import AppConfirmationDialog from './component'
export default AppConfirmationDialog
